export const campaignBannerSlider = function(container) {
  const bannerContainer = container;
  let bannerSwiper;
  if (!bannerContainer) return;
  bannerSlider();

  function bannerSlider() {
    bannerSwiper = new Swiper(bannerContainer, {
			loop: true,
			effect: 'fade',
			simulateTouch: false,
			fadeEffect: {
				crossFade: true
			},
			autoplay: {
				delay: 2000
			}
		});
  }
};
